import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
import { Paper, Stack, Typography } from "@mui/material";

import { DocumentResponse } from "@/api";
import { formatContentType, formatFileSize } from "@/common/helper/fileDownloadHelper";

interface Props {
  file: DocumentResponse;
}

export function DragOverlayContent({ file }: Props) {
  return (
    <Paper
      elevation={8}
      sx={{
        p: 1,
        maxWidth: 280,
        opacity: 0.9,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <DescriptionRounded color="primary" fontSize="small" />
        <Typography variant="body2" noWrap>
          {file.fileName} ({formatContentType(file.contentType)}, {formatFileSize(file.fileSizeBytes)})
        </Typography>
      </Stack>
    </Paper>
  );
}
